import { render } from "./AmlPolicy.vue?vue&type=template&id=e5510898"
import script from "./AmlPolicy.vue?vue&type=script&lang=js"
export * from "./AmlPolicy.vue?vue&type=script&lang=js"
script.render = render

export default script